$(document).ready(function () {
  $.StepForm.init('.jsWizard');
});
